import styled from "styled-components";

const AppWindowContentWrapper = styled.div`
  position: relative;
  padding-top: 70px;
`;

export default AppWindowContentWrapper;



// WEBPACK FOOTER //
// ./src/components/AppWindowContentWrapper.js